import React from "react";

const ModalBody = function(props) {
  let style = {};
  if (props.style) {
    style = {
      ...props.style,
    };
  }
  return (
    <div className="modal-body studio-modal-body" style={style}>
      {props.error && (
        <div className="alert alert-error" style={{ marginBottom: "10px" }}>
          {props.error}
        </div>
      )}
      {props.children}
    </div>
  );
};
export default ModalBody;
